"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'rag.settings.chunkSize.label': '分块大小',
    'rag.settings.chunkSize.description': '用于索引的文本块大小（100-2000字符）',
    'rag.settings.chunkOverlap.label': '分块重叠',
    'rag.settings.chunkOverlap.description': '块之间的重叠以保留上下文（0-500字符）',
    'rag.settings.similarityThreshold.label': '相似度阈值',
    'rag.settings.similarityThreshold.description': '搜索结果的最低相似度分数（0.1-1.0）',
    'rag.settings.defaultMaxResults.label': '默认最大结果数',
    'rag.settings.defaultMaxResults.description': '要返回的默认搜索结果数（1-20）',
    'rag.settings.maxResults.label': '最大结果数',
    'rag.settings.maxResults.description': '允许的最大搜索结果数（1-20）',
    'rag.settings.separators.label': '文本分隔符',
    'rag.settings.separators.description': '用于将文本分割成块的字符（逗号分隔）',
    'rag.settings.separators.placeholder': '输入以逗号分隔的分隔符',
    'rag.settings.separators.add': '添加分隔符',
    'rag.settings.resetToDefaults.label': '恢复默认设置',
    'rag.settings.resetToDefaults.tooltip': '将RAG设置恢复为默认值',
};
